const moment = require("moment");

function combineDateAndHour(date, hourStr) {
  const [startHours, startMins] = hourStr.split(":");
  return moment(date).hours(startHours).minutes(startMins).seconds(0);
}

module.exports = combineDateAndHour;
